<div class="pto-highlights-and-trends-main-container">
  <span class="highlights-and-trends-title">Highlights & Trends:</span>
  <div class="highlights-and-trends-cards">
    <div class="highlights-and-trends-card" *ngFor="let card of [].constructor(3), let index = index">
      <app-trend-idicator-display [indicatorName]="index === 0 ? 'down': index === 1 ? 'up' : 'critical'"></app-trend-idicator-display>
      <div class="descriptions-container" *ngIf="index === 0">
        <span class="description title"><b>Clarity</b> remains consistently low across all projects.</span>
        <span class="description score">Average score: <b>31%</b></span>
        <span class="description subtitle">Clarity remains consistently low across all projects.</span>
      </div>
      <div class="descriptions-container" *ngIf="index === 1">
        <span class="description title"><b>Engagement</b> remains consistently low across all projects.</span>
        <span class="description score">Average score: <b>92%</b></span>
        <span class="description subtitle">The indicator has remained below the healthy range for the last x check-ins.</span>
      </div>
      <div class="descriptions-container" *ngIf="index === 2">
        <span class="description title"><b>Efficiency</b> remains consistently low across all projects.</span>
        <span class="description score">Average score: <b>12%</b></span>
        <span class="description subtitle">The indicator has remained below the healthy range for the last x check-ins.</span>
      </div>
    </div>
  </div>
</div>
